module.exports = __webpack_public_path__ + "media/images/icon-check-list-03df016aeeca24338a1ae1380e39da7b.png";